import {
  Box,
  Button,
  Grid,
  makeStyles,
  MobileStepper,
  Paper,
  Typography
} from '@material-ui/core'
import { TooltipRenderProps } from 'react-joyride'

const useStyles = makeStyles({
  root: {
    background: 'none',
    '& .MuiMobileStepper-dot': {
      marginRight: '1rem'
    }
  }
})

const Tooltip: React.FC<TooltipRenderProps> = ({
  index,
  size,
  step,
  backProps,
  primaryProps,
  tooltipProps,
  skipProps
}) => {
  const classes = useStyles()

  return (
    <Paper
      sx={{
        borderRadius: '4px',
        p: 4,
        zIndex: 4000
      }}
    >
      <Grid container {...tooltipProps} flexDirection="column" spacing={2}>
        <Grid container item justifyContent="space-between">
          {step.title && (
            <Grid item>
              <Typography variant="h4">{step.title}</Typography>
            </Grid>
          )}
          <Grid item>
            <Button {...skipProps} id="skip">
              Skip
            </Button>
          </Grid>
        </Grid>
        <Grid item>{step.content}</Grid>
        <Grid
          container
          item
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          xs={12}
        >
          <Grid item xs={6}>
            <MobileStepper
              className={classes.root}
              variant="dots"
              steps={size}
              position="static"
              activeStep={index}
              backButton={<></>}
              nextButton={<></>}
            />
          </Grid>
          <Grid container item xs={6} display="flex" justifyContent="flex-end">
            {index !== 0 && (
              <Grid item>
                <Button {...backProps} id="back">
                  Back
                </Button>
              </Grid>
            )}
            <Grid item>
              <Button {...primaryProps} id="next" variant="contained">
                {index === 0 && 'Start'}
                {index !== 0 && index !== size - 1 && 'Next'}
                {index === size - 1 && 'Finish'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default Tooltip
